const T = {
  pl: {
    nav: {
      features: 'Funkcje',
      services: 'Usługi',
      onlineResults: 'Wyniki Online',
      requirements: 'Wymagania',
      contact: 'Kontakt',
      competitor: 'Zawodnik',
      rallyControl: 'Rally Control',
      contactBtn: 'Skontaktuj się',
      home: 'Strona Główna',
      competitorZone: '← Strefa Zawodnika',
      elearning: 'Szkolenie E-learning',
      competitorPage: 'Strona Zawodnika',
    },
    hero: {
      badge: 'Profesjonalne Rozwiązanie dla Sportów Motorowych',
      line1a: 'Monitoring',
      line1b: 'GPS',
      line2a: 'dla',
      line2b: 'sportów motorowych',
      subtitle:
        'Profesjonalne urządzenia GPS zaprojektowane specjalnie dla sportów motorowych. Całkowicie bezobsługowe z własnym zasilaniem. Kompaktowe oraz bezawaryjne',
      ctaOrder: 'Zamów ofertę',
      ctaFeatures: 'Zobacz możliwości',
    },
    stats: {
      maintenanceFreeValue: '100%',
      maintenanceFreeLabel: 'Bezobsługowe',
      maintenanceFreeDesc: 'Własne zasilanie, wystarczy umieścić w pojeździe',
      realtimeValue: 'Real-time',
      realtimeLabel: 'Monitoring na żywo',
      realtimeDesc: 'Pozycja, trasa i prędkość w czasie rzeczywistym',
      serviceValue: 'Serwis',
      serviceLabel: 'Wsparcie techniczne',
      serviceDesc: 'Dedykowany zespół podczas rajdu',
    },
    features: {
      sectionBadge: 'Nasze możliwości',
      sectionTitle1: 'Kompleksowe',
      sectionTitle2: 'rozwiązania',
      sectionSubtitle: 'Od zapoznania po centrum kierowania rajdem',
      learnMore: 'Dowiedz się więcej',
      items: [
        {
          title: 'Monitoring w czasie rzeczywistym',
          description:
            'Profesjonalne urządzenia GPS całkowicie bezobsługowe z własnym zasilaniem. Kompaktowe rozmiary.',
        },
        {
          title: 'Zapoznanie Rajdu',
          description:
            'Rejestracja przebiegu trasy i liczby przejazdów. Automatyczne zliczanie oraz generowanie szczegółowych raportów po zakończeniu zapoznania.',
        },
        {
          title: 'Pomiar Prędkości',
          description:
            'Specjalne strefy pomiaru średniej prędkości w wrażliwych miejscach (szkoły, obszary zabudowane). Zwiększone bezpieczeństwo podczas przygotowań.',
        },
        {
          title: 'Centrum Kierowania Rajdem',
          description:
            'Pełne wyposażenie stanowisk CKR — monitory i skonfigurowane komputery. Monitoring wszystkich pojazdów organizatora i zawodników w czasie rzeczywistym.',
        },
      ],
    },
    services: {
      sectionBadge: 'Nasze usługi',
      sectionTitle1: 'Wybierz',
      sectionTitle2: 'pakiet',
      sectionSubtitle: 'Dopasowany do potrzeb Twojego wydarzenia',
      mostPopular: 'NAJPOPULARNIEJSZY',
      contactForDetails: 'Skontaktuj się po szczegóły',
      requestQuote: 'Zamów wycenę',
      items: [
        {
          name: 'ZAPOZNANIE',
          price: 'Wycena indywidualna',
          description: 'Monitoring podczas zapoznania z trasą',
          features: [
            'Wydanie urządzeń GPS',
            'Monitoring pojazdów',
            'Monitoring prędkości',
            'Zapoznanie rajdu',
            'Automatyczne zliczanie przejazdów',
            'Generowanie raportów',
          ],
        },
        {
          name: 'MONITORING RAJDU',
          price: 'Wycena indywidualna',
          description: 'Centrum Kierowania Rajdem',
          features: [
            'Przygotowanie stanowisk dla CKR',
            'Monitoring pojazdów organizatora',
            'Monitoring zawodników',
            'Wsparcie techniczne CKR',
            'Montaż/Demontaż urządzeń na BK',
            'Wyposażenie techniczne',
          ],
        },
        {
          name: 'ZAPOZNANIE + MONITORING',
          price: 'Pakiet kompleksowy',
          description: 'Pełna obsługa wydarzenia',
          features: [
            'Wszystko z pakietu Zapoznanie',
            'Wszystko z pakietu Monitoring',
            'Dedykowany zespół 3 osobowy',
          ],
        },
      ],
    },
    onlineResults: {
      sectionBadge: 'Dodatkowa usługa',
      sectionTitle1: 'Wyniki',
      sectionTitle2: 'Online',
      sectionSubtitle: 'Profesjonalna prezentacja wyników w czasie rzeczywistym',
      card1Title: 'Integracja z TAG Heuer',
      card1Text1:
        'Oferujemy drugą aplikację dedykowaną do obsługi wyników online. Nasze rozwiązanie pozwala na prezentację wyników rajdu w czasie rzeczywistym.',
      card1Text2:
        'System umożliwia integrację z profesjonalnymi urządzeniami pomiarowymi TAG Heuer, które są standardowo wykorzystywane przez Polski Związek Motorowy (PZM).',
      card2Title: 'Wyniki + CKR = Pełna Kontrola',
      card2Text1:
        'Dzięki integracji systemu wyników z usługą śledzenia GPS jesteśmy w stanie na jednej platformie prezentować pełny status załóg w czasie rzeczywistym.',
      card2Text2:
        'Nasze rozwiązanie pozwala na natychmiastowe wyświetlanie informacji o załogach, które wystartowały oraz tych, które ukończyły odcinek specjalny.',
      ctaBtn: 'Zapytaj o wyniki online →',
      features: [
        'Prezentacja wyników w czasie rzeczywistym',
        'Integracja z urządzeniami TAG Heuer (PZM)',
        'Bezpośredni odbiór z urządzeń pomiarowych',
        'Status załóg: start i ukończenie OS',
        'Wyświetlanie na ekranach CKR',
        'Dostęp online dla kibiców',
        'Profesjonalna prezentacja danych',
        'Zwiększone bezpieczeństwo i kontrola',
      ],
    },
    requirements: {
      sectionBadge: 'Współpraca',
      sectionTitle1: 'Wymagania i',
      sectionTitle2: 'co zapewniamy',
      card1Title: 'Wymagania od organizatora',
      card2Title: 'Co zapewniamy',
      infoTitle: 'Urządzenia działają zaraz po odebraniu',
      infoText:
        'Monitoring pojazdów odbywa się natychmiast po odebraniu urządzenia. Każde urządzenie posiada wbudowaną baterię i jest gotowe do pracy od razu.',
      requirementsList: [
        'Miejsce w biurze wraz z dostępem do prądu',
        'Informacja 2 tygodnie przed o umiejscowieniu bramek i mapy rajdu',
        'Informacje o godzinach wydawania urządzeń GPS',
        'Pobieranie opłaty za urządzenia oraz kaucję (zwrot po zwrocie urządzenia)',
        'Podanie osoby do wysłania raportu',
        'Naklejka na samochód, książka drogowa, ID dla 3 osób',
        'Nocleg dla 3 osób od OA do zbierania GPS (plus 1 dzień jeśli >200km)',
      ],
      provideList: [
        'Dostarczenie i wydawanie urządzeń podczas rajdu',
        'Dojazd na rajd we własnym zakresie',
        'Obecność osoby do czasu zwrotu urządzeń',
        'Faktura VAT z terminem płatności 7 dni',
        'Przesłanie raportu do organizatora',
        'Kontrola i wymiana wadliwych urządzeń',
        'Instrukcje i opisy do regulaminu imprezy',
        'Monitoring zaraz po odebraniu urządzenia',
      ],
    },
    gallery: {
      sectionBadge: 'System w akcji',
      sectionTitle1: 'Zobacz',
      sectionTitle2: 'nasz system',
      sectionSubtitle: 'Zrzuty ekranu z aplikacji i centrum kierowania rajdem',
      items: [
        { title: 'Centrum Kierowania Rajdem', desc: 'Pełny monitoring wszystkich pojazdów' },
        { title: 'Mapa z trasą rajdu', desc: 'Odcinki specjalne i punkty kontrolne' },
        { title: 'Wszystkie informacje', desc: 'Informacje o pojeździe, prędkości itd' },
        { title: 'Potrzebna infrastruktura do CKR', desc: 'posiadamy cały sprzęt do obsługi GPS' },
      ],
    },
    partners: {
      sectionBadge: 'Zaufali nam',
      sectionTitle: 'Organizatorzy z całej Polski',
    },
    contact: {
      sectionTitle1: 'Skontaktuj się',
      sectionTitle2: 'z nami',
      subtitle:
        'Profesjonalny monitoring GPS dla Twojego rajdu. Zespół MonitGPS jest do Twojej dyspozycji.',
      callNow: 'Zadzwoń teraz',
      freeQuote: 'Darmowa wycena',
      vatInvoice: 'Faktura VAT 7 dni',
      fullSupport: 'Kompleksowe wsparcie',
    },
    footer: {
      description:
        'Profesjonalny system monitoringu GPS dla rajdów terenowych i sportów motorowych.',
      services: 'Usługi',
      rallyRecon: 'Zapoznanie rajdu',
      monitoringCKR: 'Monitoring CKR',
      onlineResults: 'Wyniki online',
      requirements: 'Wymagania',
      contact: 'Kontakt',
      system: 'System',
      maintenanceFreeDevices: 'Bezobsługowe urządzenia',
      realtimeMonitoring: 'Monitoring real-time',
      tagHeuerIntegration: 'Integracja TAG Heuer',
      support247: 'Wsparcie 24/7',
      copyright: '© 2024 MonitGPS. Wszystkie prawa zastrzeżone.',
      privacyPolicy: 'Polityka Prywatności',
      tagline: 'Profesjonalny monitoring dla sportów motorowych',
    },
    zawodnikLanding: {
      badge: 'Wybierz swoją dyscyplinę',
      title1: 'Strefa',
      title2: 'Zawodnika',
      subtitle:
        'Wszystkie potrzebne materiały, instrukcje obsługi urządzeń oraz możliwość zamówienia zestawów montażowych — wybierz swoją kategorię.',
      rallyTitle: 'Rajdy',
      rallyDesc:
        'Instrukcje, schematy instalacji i formularz zamówienia zestawu montażowego dla zawodników rajdowych.',
      rallyBtn: 'Przejdź do sekcji Rajdy',
      climbTitle: 'Wyścig Górski',
      climbDesc:
        'Dedykowane materiały, instrukcje i formularz rejestracji dla zawodników wyścigów górskich.',
      climbBtn: 'Przejdź do sekcji Wyścig Górski',
      elearningBtn: 'Otwórz obowiązkowe Szkolenie E-learning',
    },
    downloads: {
      sectionBadge: 'Do pobrania',
      sectionTitle1: 'Instrukcje i',
      sectionTitle2: 'materiały',
      userManualTitle: 'Instrukcja Zawodnika',
      userManualDescRally:
        'Szczegółowa instrukcja użytkowania trackerów MonitGPS przeznaczona dla zawodników i załóg rajdowych.',
      userManualDescClimb:
        'Szczegółowa instrukcja użytkowania trackerów MonitGPS przeznaczona dla zawodników wyścigów górskich.',
      installationTitle: 'Instrukcja Instalacji',
      installationTitleClimb: 'Instrukcje Instalacji',
      installationDescRally:
        'Instrukcja i schemat poprawnego montażu okablowania oraz mocowań dla urządzeń GPS w samochodzie rajdowym.',
      installationDescClimb:
        'Pobierz odpowiednie instrukcje montażu urządzenia GPS w pojeździe wyścigowym.',
      installBtnLabel: 'Instrukcja Instalacji',
      ledInstallBtnLabel: 'Instrukcja Instalacji Ekranu LED',
      cableMountTitle: 'Montaż Linki',
      downloadBtn: 'Pobierz PDF',
    },
    orderKit: {
      sectionBadge: 'Wyposażenie pojazdu',
      sectionTitle1: 'Zamów',
      sectionTitle2: 'Zestaw / Wypożyczenie',
      subtitleRally:
        'Zamów dedykowany zestaw do montażu urządzenia MonitGPS na stałe, lub zgłoś chęć wypożyczenia trackera na pojedynczy rajd.',
      subtitleClimb:
        'Zamów dedykowany zestaw do montażu urządzenia MonitGPS na stałe, lub zgłoś chęć wypożyczenia trackera na wyścig górski.',
      pricingTitle: 'Cennik dla Zawodnika:',
      pricingSubtitle: 'Zgłoś chęć wypożyczenia urządzenia lub kup na własność zestaw montażowy.',
      rental: 'Wypożyczenie',
      rentalUnitRally: 'netto / rajd',
      rentalUnitClimb: 'netto / wyścig',
      kitPrice: 'Cena Zestawu',
      kitUnit: 'netto / szt.',
      antenna: 'Antena 2 w 1 (GPS, GPRS)',
      ramMounts: 'Uchwyty montażowe RAM',
      ramOriginal: 'Oryginalne elementy mocujące marki RAM:',
      powerCable: 'Kabel zasilający',
      cableLen3m: 'Długość kabla: 3m',
      cableLen1m: 'Długość kabla: 1m',
      vehicleMount: 'Uchwyt do pojazdu:',
      bodyMount: 'Uchwyt do karoserii (RAM-B-347U-BT)',
      cageMount: 'Uchwyt do rury klatki:',
      connector: 'Ramię-łącznik: RAM-B-201U',
      ledTitle: 'Wkrótce w ofercie: Ekran LED',
      ledDesc:
        'Wkrótce dostępny będzie wymagany dodatkowy ekran LED montowany przy kierowcy, który poprzez sygnały świetlne powiadomi o zmianie statusu, jak np. RED FLAG.',
      formTitle: 'Formularz zamówienia',
      nameLabel: 'Imię i nazwisko / Nazwa zespołu',
      namePlaceholder: 'Skoda Rally Team',
      emailLabel: 'Adres Email',
      emailPlaceholder: 'kontakt@team.com',
      phoneLabel: 'Telefon Kontaktowy',
      phonePlaceholder: '+48 123 456 789',
      invoiceQuestion: 'Czy potrzebujesz faktury?',
      invoiceNo: 'Nie',
      invoiceYes: 'Tak',
      invoiceTitle: '🧾 Dane do faktury',
      nipLabel: 'NIP',
      nipPlaceholder: '123-456-78-90',
      companyLabel: 'Nazwa firmy',
      companyPlaceholder: 'Racing Team Sp. z o.o.',
      addressLabel: 'Adres (ulica i numer)',
      addressPlaceholder: 'ul. Wyścigowa 1',
      cityLabel: 'Kod pocztowy i miasto',
      cityPlaceholder: '00-000 Warszawa',
      notesLabelRally: 'Dodatkowe uwagi (opcjonalnie)',
      notesLabelClimb: 'Dodatkowe uwagi / Szczegóły',
      notesPlaceholder: 'Adres do wysyłki. Ilość sztuk.',
      mountTypeLabel: 'Typ montażu',
      mountTypePlaceholder: 'Wybierz typ montażu...',
      mountToTunnel: 'Do tunelu',
      mountToCage: 'Do klatki',
      cageDiameterLabel: 'Średnica rury klatki',
      cageDiameterPlaceholder: 'Wybierz średnicę...',
      submitBtn: 'Wyślij Zamówienie',
      sendingBtn: 'Wysyłanie...',
      formNote:
        'Kliknięcie przycisku wyśle zamówienie do nas. Skontaktujemy się z Tobą w celu potwierdzenia zamówienia.',
      successTitle: 'Zamówienie przyjęte!',
      successText:
        'Dziękujemy, Twoje zamówienie zostało wysłane. Skontaktujemy się z Tobą wkrótce.',
      errorText:
        'Wystąpił błąd podczas wysyłania zamówienia. Prosimy skontaktować się telefonicznie.',
      errorConn: 'Wystąpił problem z połączeniem lub serwerem PHP.',
    },
    contactSection: {
      title: 'Kontakt z działem technicznym',
    },
    rally: {
      heroTitle1: 'Zawodnik —',
      heroTitle2: 'Rajdy',
      heroSubtitle:
        'Wszystkie potrzebne materiały, instrukcje obsługi urządzeń oraz możliwość zamówienia zestawów montażowych w jednym miejscu.',
      elearningBtn: 'Otwórz obowiązkowe Szkolenie E-learning',
    },
    climb: {
      heroTitle1: 'Zawodnik —',
      heroTitle2: 'Wyścig Górski',
      heroSubtitle:
        'Materiały, instrukcje obsługi urządzeń oraz możliwość zamówienia zestawów montażowych dla zawodników wyścigów górskich.',
    },
    elearning: {
      heroTitle1: 'Szkolenie',
      heroTitle2: 'E-learningowe',
      heroSubtitle:
        'Zapraszamy do skorzystania z naszej platformy e-learningowej, gdzie w przystępny sposób przejdziesz przez krótkie szkolenie.',
      readyTitle1: 'Gotowy do',
      readyTitle2: 'startu?',
      subtitle: 'Szkolenie E-LEARNING',
      launchBtn: 'Uruchom Szkolenie',
      redirectNote: 'Zostaniesz przekierowany do zewnętrznego portalu:',
    },
  },
  en: {
    nav: {
      features: 'Features',
      services: 'Services',
      onlineResults: 'Online Results',
      requirements: 'Requirements',
      contact: 'Contact',
      competitor: 'Competitor',
      rallyControl: 'Rally Control',
      contactBtn: 'Contact Us',
      home: 'Home',
      competitorZone: '← Competitor Zone',
      elearning: 'E-learning Training',
      competitorPage: 'Competitor Page',
    },
    hero: {
      badge: 'Professional Solution for Motorsport',
      line1a: 'GPS',
      line1b: 'Monitoring',
      line2a: 'for',
      line2b: 'Motorsport',
      subtitle:
        'Professional GPS devices designed specifically for motorsport. Completely maintenance-free with built-in power supply. Compact and reliable.',
      ctaOrder: 'Request Quote',
      ctaFeatures: 'Explore Features',
    },
    stats: {
      maintenanceFreeValue: '100%',
      maintenanceFreeLabel: 'Maintenance-Free',
      maintenanceFreeDesc: 'Built-in power, just place it in the vehicle',
      realtimeValue: 'Real-time',
      realtimeLabel: 'Live Monitoring',
      realtimeDesc: 'Position, route and speed in real time',
      serviceValue: 'Service',
      serviceLabel: 'Technical Support',
      serviceDesc: 'Dedicated team during the rally',
    },
    features: {
      sectionBadge: 'Our Capabilities',
      sectionTitle1: 'Comprehensive',
      sectionTitle2: 'solutions',
      sectionSubtitle: 'From reconnaissance to rally control center',
      learnMore: 'Learn more',
      items: [
        {
          title: 'Real-time Monitoring',
          description:
            'Professional GPS devices, completely maintenance-free with built-in power supply. Compact dimensions.',
        },
        {
          title: 'Rally Reconnaissance',
          description:
            'Route tracking and pass counting. Automatic counting and detailed report generation after reconnaissance completion.',
        },
        {
          title: 'Speed Measurement',
          description:
            'Special average speed zones in sensitive areas (schools, residential zones). Enhanced safety during preparations.',
        },
        {
          title: 'Rally Control Center',
          description:
            'Full RCC station equipment — monitors and configured computers. Real-time monitoring of all organizer vehicles and competitors.',
        },
      ],
    },
    services: {
      sectionBadge: 'Our Services',
      sectionTitle1: 'Choose Your',
      sectionTitle2: 'Package',
      sectionSubtitle: 'Tailored to your event needs',
      mostPopular: 'MOST POPULAR',
      contactForDetails: 'Contact us for details',
      requestQuote: 'Request Quote',
      items: [
        {
          name: 'RECONNAISSANCE',
          price: 'Individual Quote',
          description: 'Monitoring during route reconnaissance',
          features: [
            'GPS Device Distribution',
            'Vehicle Monitoring',
            'Speed Monitoring',
            'Rally Reconnaissance',
            'Automatic Pass Counting',
            'Report Generation',
          ],
        },
        {
          name: 'RALLY MONITORING',
          price: 'Individual Quote',
          description: 'Rally Control Center',
          features: [
            'RCC Station Setup',
            'Organizer Vehicle Monitoring',
            'Competitor Monitoring',
            'RCC Technical Support',
            'Device Installation/Removal at SS',
            'Technical Equipment',
          ],
        },
        {
          name: 'RECONNAISSANCE + MONITORING',
          price: 'Full Package',
          description: 'Complete Event Service',
          features: [
            'Everything from Reconnaissance Package',
            'Everything from Monitoring Package',
            'Dedicated 3-person team',
          ],
        },
      ],
    },
    onlineResults: {
      sectionBadge: 'Additional Service',
      sectionTitle1: 'Online',
      sectionTitle2: 'Results',
      sectionSubtitle: 'Professional real-time results presentation',
      card1Title: 'TAG Heuer Integration',
      card1Text1:
        'We offer a second application dedicated to online results management. Our solution allows real-time presentation of rally results.',
      card1Text2:
        'The system enables integration with professional TAG Heuer timing equipment, which is the standard used by the Polish Motor Union (PZM).',
      card2Title: 'Results + RCC = Full Control',
      card2Text1:
        'By integrating the results system with GPS tracking, we can present the full status of all crews on a single platform in real time.',
      card2Text2:
        'Our solution allows instant display of information about crews that have started and those that have finished the special stage.',
      ctaBtn: 'Inquire about online results →',
      features: [
        'Real-time results presentation',
        'Integration with TAG Heuer devices (PZM)',
        'Direct input from timing equipment',
        'Crew status: stage start and finish',
        'Display on RCC screens',
        'Online access for spectators',
        'Professional data presentation',
        'Enhanced safety and control',
      ],
    },
    requirements: {
      sectionBadge: 'Cooperation',
      sectionTitle1: 'Requirements and',
      sectionTitle2: 'What We Provide',
      card1Title: 'Organizer Requirements',
      card2Title: 'What We Provide',
      infoTitle: 'Devices Work Immediately After Collection',
      infoText:
        'Vehicle monitoring starts immediately after the device is collected. Each device has a built-in battery and is ready to use right away.',
      requirementsList: [
        'Office space with power access',
        'Information 2 weeks in advance about gate placement and rally map',
        'Information about GPS device distribution hours',
        'Collecting device fees and deposits (refunded upon device return)',
        'Providing a contact person for report delivery',
        'Car sticker, road book, ID for 3 people',
        'Accommodation for 3 people from SA until GPS collection (plus 1 day if >200km)',
      ],
      provideList: [
        'Delivery and distribution of devices during the rally',
        'Self-arranged transportation to the rally',
        'Staff presence until device return',
        'VAT invoice with 7-day payment terms',
        'Report delivery to the organizer',
        'Inspection and replacement of defective devices',
        'Instructions and descriptions for the event regulations',
        'Monitoring starts immediately after device collection',
      ],
    },
    gallery: {
      sectionBadge: 'System in Action',
      sectionTitle1: 'See',
      sectionTitle2: 'our system',
      sectionSubtitle: 'Screenshots from the app and rally control center',
      items: [
        { title: 'Rally Control Center', desc: 'Full monitoring of all vehicles' },
        { title: 'Rally route map', desc: 'Special stages and control points' },
        { title: 'All information', desc: 'Vehicle info, speed, and more' },
        { title: 'Required RCC infrastructure', desc: 'We have all the GPS support equipment' },
      ],
    },
    partners: {
      sectionBadge: 'Trusted By',
      sectionTitle: 'Organizers from all over Poland',
    },
    contact: {
      sectionTitle1: 'Contact',
      sectionTitle2: 'Us',
      subtitle: 'Professional GPS monitoring for your rally. The MonitGPS team is at your disposal.',
      callNow: 'Call Now',
      freeQuote: 'Free Quote',
      vatInvoice: '7-day VAT Invoice',
      fullSupport: 'Full Support',
    },
    footer: {
      description: 'Professional GPS monitoring system for off-road rallies and motorsport.',
      services: 'Services',
      rallyRecon: 'Rally Reconnaissance',
      monitoringCKR: 'RCC Monitoring',
      onlineResults: 'Online Results',
      requirements: 'Requirements',
      contact: 'Contact',
      system: 'System',
      maintenanceFreeDevices: 'Maintenance-Free Devices',
      realtimeMonitoring: 'Real-time Monitoring',
      tagHeuerIntegration: 'TAG Heuer Integration',
      support247: '24/7 Support',
      copyright: '© 2024 MonitGPS. All rights reserved.',
      privacyPolicy: 'Privacy Policy',
      tagline: 'Professional monitoring for motorsport',
    },
    zawodnikLanding: {
      badge: 'Choose Your Discipline',
      title1: 'Competitor',
      title2: 'Zone',
      subtitle:
        'All the materials you need, device manuals, and the option to order installation kits — choose your category.',
      rallyTitle: 'Rallies',
      rallyDesc:
        'Instructions, installation diagrams, and order form for installation kits for rally competitors.',
      rallyBtn: 'Go to Rally Section',
      climbTitle: 'Hill Climb',
      climbDesc: 'Dedicated materials, instructions, and registration form for hill climb competitors.',
      climbBtn: 'Go to Hill Climb Section',
      elearningBtn: 'Open Mandatory E-learning Training',
    },
    downloads: {
      sectionBadge: 'Downloads',
      sectionTitle1: 'Instructions &',
      sectionTitle2: 'Materials',
      userManualTitle: 'Competitor Instructions',
      userManualDescRally:
        'Detailed usage instructions for MonitGPS trackers for rally competitors and crews.',
      userManualDescClimb:
        'Detailed usage instructions for MonitGPS trackers for hill climb competitors.',
      installationTitle: 'Installation Manual',
      installationTitleClimb: 'Installation Guides',
      installationDescRally:
        'Installation instructions and wiring diagram for GPS devices in a rally car.',
      installationDescClimb:
        'Download the appropriate GPS device installation guides for your racing vehicle.',
      installBtnLabel: 'Installation Manual',
      ledInstallBtnLabel: 'LED Display Installation',
      cableMountTitle: 'Safety Lanyard Installation',
      downloadBtn: 'Download PDF',
    },
    orderKit: {
      sectionBadge: 'Vehicle Equipment',
      sectionTitle1: 'Order',
      sectionTitle2: 'Kit / Rental',
      subtitleRally:
        'Order a dedicated installation kit for your MonitGPS device, or register interest in renting a tracker for a single rally.',
      subtitleClimb:
        'Order a dedicated installation kit for your MonitGPS device, or register interest in renting a tracker for a hill climb.',
      pricingTitle: 'Competitor Pricing:',
      pricingSubtitle: 'Register interest in renting a device or purchase an installation kit.',
      rental: 'Rental',
      rentalUnitRally: 'net / rally',
      rentalUnitClimb: 'net / race',
      kitPrice: 'Kit Price',
      kitUnit: 'net / unit',
      antenna: '2-in-1 Antenna (GPS, GPRS)',
      ramMounts: 'RAM Mounting Brackets',
      ramOriginal: 'Original RAM brand mounting components:',
      powerCable: 'Power Cable',
      cableLen3m: 'Cable length: 3m',
      cableLen1m: 'Cable length: 1m',
      vehicleMount: 'Vehicle mount:',
      bodyMount: 'Body mount (RAM-B-347U-BT)',
      cageMount: 'Cage tube mount:',
      connector: 'Connector arm: RAM-B-201U',
      ledTitle: 'Coming soon: LED Display',
      ledDesc:
        'A required additional LED display mounted near the driver will soon be available, which will notify about status changes via light signals, such as RED FLAG.',
      formTitle: 'Order Form',
      nameLabel: 'Full Name / Team Name',
      namePlaceholder: 'Skoda Rally Team',
      emailLabel: 'Email Address',
      emailPlaceholder: 'contact@team.com',
      phoneLabel: 'Contact Phone',
      phonePlaceholder: '+48 123 456 789',
      invoiceQuestion: 'Do you need an invoice?',
      invoiceNo: 'No',
      invoiceYes: 'Yes',
      invoiceTitle: '🧾 Invoice Details',
      nipLabel: 'VAT ID',
      nipPlaceholder: '123-456-78-90',
      companyLabel: 'Company Name',
      companyPlaceholder: 'Racing Team Ltd.',
      addressLabel: 'Address (street and number)',
      addressPlaceholder: '1 Racing Street',
      cityLabel: 'Postal code and city',
      cityPlaceholder: '00-000 Warsaw',
      notesLabelRally: 'Additional Notes (optional)',
      notesLabelClimb: 'Additional Notes / Details',
      notesPlaceholder: 'Shipping address. Quantity.',
      mountTypeLabel: 'Installation Type',
      mountTypePlaceholder: 'Select installation type...',
      mountToTunnel: 'To tunnel',
      mountToCage: 'To cage',
      cageDiameterLabel: 'Cage tube diameter',
      cageDiameterPlaceholder: 'Select diameter...',
      submitBtn: 'Send Order',
      sendingBtn: 'Sending...',
      formNote:
        'Clicking the button will send your order to us. We will contact you to confirm your order.',
      successTitle: 'Order Received!',
      successText: 'Thank you, your order has been sent. We will contact you soon.',
      errorText: 'An error occurred while sending your order. Please contact us by phone.',
      errorConn: 'A connection or server error occurred.',
    },
    contactSection: {
      title: 'Contact Technical Support',
    },
    rally: {
      heroTitle1: 'Competitor —',
      heroTitle2: 'Rallies',
      heroSubtitle:
        'All materials, device manuals, and installation kit order forms in one place.',
      elearningBtn: 'Open Mandatory E-learning Training',
    },
    climb: {
      heroTitle1: 'Competitor —',
      heroTitle2: 'Hill Climb',
      heroSubtitle:
        'Materials, device manuals, and installation kit order forms for hill climb competitors.',
    },
    elearning: {
      heroTitle1: 'E-learning',
      heroTitle2: 'Training',
      heroSubtitle:
        'We invite you to use our e-learning platform, where you can complete a short training course in a simple and accessible way.',
      readyTitle1: 'Ready to',
      readyTitle2: 'Start?',
      subtitle: 'E-LEARNING TRAINING',
      launchBtn: 'Launch Training',
      redirectNote: 'You will be redirected to an external portal:',
    },
  },
};

export default T;
